import {AppParameters} from "../../../AppParameters";
export default class DefaultContentModifier
{
    #routing;
    #http;
    #contentUtils;
    #helper;
    #constants;
    #debouncePeakAhead;
    constructor(routing, http, contentUtils, helper, constants, _) {
        //TODO:: Refactor all of these, especially the mixins
        this.#routing = routing;
        this.#http = http;
        this.#contentUtils = contentUtils;
        this.#helper = helper;
        this.#constants = constants;
        this.#debouncePeakAhead = _.debounce(this.#contentUtils.methods.showPeakAhead, 750);
    }
    modifyPreRender(content) {

    }
    modifyPostRender(contentRootElement, sectionId) {
        this.updateSectionId(contentRootElement, sectionId);
        this.bindContentLinks(contentRootElement);
        this.applyTitleAttributes(contentRootElement);
    }
    /**
    * To bind links in DOM we need a section ID to be attached to pick the element
    */
    updateSectionId(contentRootElement, sectionId){
        const sectionElements = contentRootElement.getElementsByTagName('section');
        if (sectionElements.length > 0) {
            const section = sectionElements[0];
            section.setAttribute('section-number', sectionId);
        }
    }
    getContentLinkTargetId(link) {
        const href = link.getAttribute('href');
        if (!href || href.length <= 1) return null;

        if (href.startsWith('#')) {
            return href.substring(1);
        }

        const match = href.match(/\/book\/(linkit|externallinkit)\/(.+)$/);
        return match ? match[2] : null;
    }
    bindContentLinks(contentRootElement) {
        const links = contentRootElement.getElementsByTagName('a');
        Array.from(links).forEach(link => {
            const targetId = this.getContentLinkTargetId(link);

            if (targetId && (targetId.includes('_PromASTM_') || targetId.includes('_ASTM_'))
                && !link.getAttribute('data-astm-compass')) {
                    let linkText = document.createTextNode(link.text);
                    link.parentNode.insertBefore(linkText, link);
                    link.text = '';
            }

            const astmModal = link.getAttribute("astm-modal");
            const sectionNumber = link.getAttribute("section-number");

            // If ASTM reference link
            if (astmModal && sectionNumber && this.#helper.methods.isAstmCompassEnabled()) {
                this.bindAstmEvents(link, astmModal, sectionNumber);
            } else {
                if (targetId) {
                    link.setAttribute('href', AppParameters.base_route + `/lookup/${targetId}`);
                    this.bindContentEvents(link, targetId);
                }
            }
        });
    }

    bindAstmEvents(link, astmRefStd, sectionNumber) {
        link.addEventListener('click', event => {
            event.preventDefault();
            this.redirectToAstmDocument(astmRefStd, sectionNumber);
        });

        link.addEventListener('mouseover', event => {
            this.debouncePeakAhead({
                show: true,
                event,
                targetId: astmRefStd,
                isEsAcLink: false,
                isAstmLink: this.checkIsAstmLink(link)
            });
        });

        link.addEventListener('mouseout', () => {
            this.debouncePeakAhead.cancel();
            EventBus.fire('togglePeakAhead', false);
        });
    }

    bindContentEvents(link, targetId) {
        const isEsAcLink = this.checkIsEsAcLink(link.getAttribute('data-ac'));

        const handleClick = (event) => {
            event.preventDefault();

            const isAstmCompass = this.#helper.methods.isAstmCompassEnabled();
            const isAstmLink = targetId.includes('_PromASTM_') || targetId.includes('_ASTM_');

            if (isAstmCompass && isAstmLink) {
                const astmRefStd = this.extractAstmRefStd(targetId);
                const sectionNumber = link.closest('section')?.getAttribute("section-number");
                if (astmRefStd && sectionNumber) {
                    this.redirectToAstmDocument(astmRefStd, sectionNumber);
                } else {
                    this.showAstmErrorModal();
                }

            } else if (isEsAcLink && this.#helper.methods.isEsAcScopeAcEnabled()) {
                this.#contentUtils.methods.showAcScopeModal(link.getAttribute("data-ac"));
            } else {
                this.handleContentLink(targetId);
            }
        };

        const handleMouseOver = (event) => {
            this.#debouncePeakAhead({
                show: true,
                event,
                targetId,
                isEsAcLink,
                isAstmLink: this.checkIsAstmLink(link)
            });
        };

        const handleMouseOut = () => {
            this.#debouncePeakAhead.cancel();
            EventBus.fire('togglePeakAhead', false);
        };

        link.addEventListener('click', handleClick);
        link.addEventListener('mouseover', handleMouseOver);
        link.addEventListener('mouseout', handleMouseOut);
    }

    extractAstmRefStd(targetId) {
        const promMatch = targetId.includes('_PromASTM_') ? targetId.match(/RefStd(.*)/) : null;
        const astmMatch = targetId.includes('_ASTM_') ? targetId.match(/ASTM(.*)/) : null;
        return (promMatch || astmMatch)?.[1] || targetId;
    }

    applyTitleAttributes(contentRootElement) {
        const attributeMappings = [
            {
                selectors: ['[data-changed="changed_level0"]', '.changed_ICC', '.change_virginia'],
                message: 'Technical code changes from previous edition of the I-Codes are shown in blue text'
            },
            {
                selectors: ['[data-changed="changed_level1"]', '[class^="changed_nonICC"]'],
                message: 'National (outside the US) and state amendments and errata to the I-Codes are shown in red text'
            },
            {
                selectors: ['[data-changed="changed_level2"]', '.changed_level2', '.changed_nonICC_NYC'],
                message: 'City of local amendments and errata to the I-Codes are shown in fuchsia text'
            },
            {
                selectors: ['[class^="deletion_marker"]', '.deletionMarker'],
                message: 'Deletion indicators are provided in margin where an entire section, paragraph, table or exception has been deleted from the prior cycle of the title.',
                icon: '\u{27A1}'
            },
            {
                selectors: ['.relocated_to'],
                message: 'Single asterisk indicates text or table has been relocated within the code. Full relocation table listed in Preface.'
            },
            {
                selectors: ['.changed_to'],
                message: 'Double asterisk indicates text or table immediately following it has been relocated from elsewhere in the code. Full relocation table listed in Preface.'
            }
        ];

        attributeMappings.forEach(({ selectors, message, icon }) => {
            this.insertTitle(contentRootElement, selectors, message, icon);
        });
    }

    insertTitle(contentRootElement, selectorArray, message, icon = null) {
        contentRootElement.querySelectorAll(selectorArray.join(',')).forEach(element => {
            element.title = message;
            if (icon && !element.classList.contains('deletion_marker_nonICC')) {
                this.applyDeletionMarker(element, icon);
            }
        });
    }

    applyDeletionMarker(element, icon) {
        let hasText = element.textContent.trim() !== '';
        let parent = element.parentNode;

        if (hasText && parent) {
            let textSpan = document.createElement('span');
            textSpan.classList.add('deletion-marker-text');
            textSpan.textContent = element.textContent;
            element.textContent = '';
            parent.insertBefore(textSpan, element.nextSibling);
        }

        let iconClass = 'hex-deletion-marker ';

        if (element.tagName === 'TD' || element.classList.contains("in-table")) {
            iconClass += 'hex-deletion-marker-table ';
            if (!element.textContent) iconClass += 'hex-deletion-marker-table-blank';
            element.closest('table')?.classList.add('hex-deletion-marker-table-margin');
        } else if (element.classList.contains("in-table-note")) {
            iconClass += 'hex-deletion-marker-table-note';
        } else if (element.classList.contains("in-def-item")) {
            iconClass += 'hex-deletion-def-item';
        } else if (element.tagName === 'LI' || element.classList.contains("in-list")) {
            iconClass += 'hex-deletion-marker-list-text';
        } else if (parent) {
            if (parent.tagName === 'DIV' || hasText) {
                iconClass += 'hex-deletion-marker-div-text';
            } else if (parent.tagName === 'P') {
                iconClass += 'hex-deletion-marker-paragraph-text';
            }
        }

        element.innerHTML = `<span class="${iconClass}">${icon}</span> ${element.textContent}`;
    }

    handleContentLink(targetId) {
        const selector = `#contentParent [id*='${targetId}' i]`;
        const element = document.querySelector(selector);

        if (element) {
            return this.#contentUtils.methods.handleTargetScroll(element);
        }

        window.location = this.#routing.generate('content_lookup', { id: targetId });
    }

    showPeakAhead(data) {
        EventBus.fire('togglePeakAhead', data);
    }

    checkIsEsAcLink(isEsAcLink) {
        return isEsAcLink ? this.#constants.esAcLink : '';
    }

    checkIsAstmLink(link) {
        return !!link.getAttribute('data-astm-compass');
    }
    showAstmErrorModal() {
        let data = {
            show: true,
            astmError: true,
            errorMessage: 'ASTM RefStd not found'
        }
        EventBus.fire("astmModal", data);
    }
    redirectToAstmDocument(astmRefStd, sectionNumber) {
        let url = this.#routing.generate('astm_standard_info', {iccDesignation: astmRefStd});
        this.#http.get(url).then(response => {
            let result = response.data.data ? response.data.data : null;
            let astmDocument = result ? result.document : null;

            if (astmDocument) {
                window.location.href = this.#routing.generate("content_document_slug", {
                    documentSlug: astmDocument.document_slug,
                    contentId: sectionNumber
                });
            } else {
                this.showAstmErrorModal();
            }
        });
    }
}